import { useEffect, useState } from "react";
import { activateSubscription } from "../queries/activateSubscription";


export const usePaymentReturn = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('checkoutToken');
    const isSuccessful = 'true' === urlParams.get('success')
    const [loading, setLoading] = useState(false)
    const [activated, setActivated] = useState(false)

    useEffect( () => {

        ( async () => {

            if(null !== token)
            {
                try{
                    setLoading(true)
                    await activateSubscription(token)
                    setLoading(false)
                    setActivated(true)
                }catch
                {
                    setActivated(false)
                    setLoading(false)
                }
            }

        } )()

    }, [token] )
    
    return { isSuccessful, loading, activated }
}